import React, { Component } from "react";
import AllCatsTable from "../table/AllCatsTable";
import { Divider, Row, Layout, Popover, Icon } from "antd";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
// import CatLevels from "../settings/CatLevels";
// import HorizontalAdPopup from "../ads/HorizontalAdPopup";
import version from "./version";
import VenatusAd from "../../components/ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../components/ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_SIDE_RAIL,
  VENATUS_DESKTOP_MULTISIZE_LEADERBOARD,
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_DESKTOP_INCONTENT,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_MOBILE_STICKY_FOOTER,
  VENATUS_RICH_MEDIA,
} from "../../components/utilities/constants";

const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com:5000/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class AllCats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportHeight: 0,
      catLevel: 30,
    };
  }

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initsgeView();

    document.title = "모든 냥코 | 냥코 대전쟁 위키: 냥코 스탯";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 768) {
      adjustViewport = 135;
    } else {
      adjustViewport = 240;
    }

    this.setState({
      viewportHeight: window.innerHeight - adjustViewport,
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  // onInputNumberChange(value) {
  //   this.setState({ catLevel: value });
  // }

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              float: "left",
            }}
          >
            모든 냥코
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={<div>Updated to BattleCats Version {version}</div>}
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
          {this.state.viewportWidth > 1024 ? (
            <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_LEADERBOARD} />
          ) : (
            <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_LEADERBOARD} />
          )}
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content style={{ padding: "0 0px" }}>
            {/* <CatLevels
              value={30}
              onChange={this.onInputNumberChange.bind(this)}
            /> */}
            {/* <Row style={{ padding: "8px 0 0 0" }}>
              <h2>
                Cat Levels:{" "}
                <InputNumber
                  min={1}
                  max={999}
                  defaultValue={30}
                  onChange={this.onInputNumberChange.bind(this)}
                />
              </h2>
            </Row> */}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <AllCatsTable
                viewportHeight={this.state.viewportHeight}
                catLevel={this.state.catLevel}
              />
            </Row>
            <Row style={{ height: "50px" }}> </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_MULTISIZE_LEADERBOARD} />
        ) : (
          <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_LEADERBOARD} />
        )}
        <div>
          <VenatusAd
            placementId={VENATUS_RICH_MEDIA}
            style={{ display: "none" }}
          />
        </div>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="9278168535"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default AllCats;

AllCats.propTypes = {
  applyViewportChange: PropTypes.number,
};

AllCats.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/AllCats.js